<template>
    <div class="service-section pt-100 pb-70 service-details">
        <div class="container">
            <div class="row">
                <div class="col-lg-12 pb-30">
                    <div class="forum-details desk-pad-right-40">
                        <div class="row">
                            <h3>{{ $t('services.details.serviceTwo.introTitle') }}</h3>
                            <p>{{ $t('services.details.serviceTwo.introBody') }}</p>
                            <p>{{ $t('services.details.serviceTwo.conclusion') }}</p>
                            <div class="col-12 col-sm-6">
                                <img v-lazy="$ossImg(localizedImg('service/service-2-2.jpg'))" alt="service">
                            </div>
                            <div class="col-12 col-sm-6">
                                <img v-lazy="$ossImg(localizedImg('service/service-2-3.jpg'))" alt="service">
                            </div>
                        </div>
                        <h2>{{ $t('services.details.serviceTwo.title') }}</h2>
                        <p>{{ $t('services.details.serviceTwo.insight') }}</p>
                        <p>{{ $t('services.details.serviceTwo.conclusion') }}</p>
                        <img v-lazy="$ossImg(localizedImg('service/service-2-1.jpg'))" alt="service">
                    </div>
                </div>
              
            </div>
        </div>
    </div>
</template>

<script>
import localizedImageMixin from '@/mixins/localizedImageMixin'

export default {
    name: 'ServicesDetails',
    mixins: [localizedImageMixin]
}
</script>
